import _toConsumableArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './MultiFilter.css';
import React from 'react';
import IconChevronDown from '../../resources/icons/IconChevronDown.svg';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { removeQueryString } from '../Listing';
import { useHistory } from 'react-router-dom';
import { mobileCheck } from "../../utils";
var compareArray = function compareArray(arr1, arr2) {
  return arr1.length === arr2.length && arr1.every(function (element) {
    return arr2.includes(element);
  });
};
var MultiFilter = function MultiFilter(_ref) {
  var setFilterDropdownState = _ref.setFilterDropdownState,
    setFilterMultipleChoicesState = _ref.setFilterMultipleChoicesState,
    resetFilterChoiceState = _ref.resetFilterChoiceState,
    items = _ref.items,
    filters = _ref.filters,
    isOpen = _ref.isOpen,
    label = _ref.label,
    filterName = _ref.filterName,
    resultsAmount = _ref.resultsAmount,
    clearAllLabel = _ref.clearAllLabel,
    showNResultsLabel = _ref.showNResultsLabel,
    formattedItems = _ref.formattedItems,
    fitlersValueAnalytics = _ref.fitlersValueAnalytics,
    filtersShowResultsAnalytics = _ref.filtersShowResultsAnalytics,
    params = _ref.params,
    fitlersCategoryAnalytics = _ref.fitlersCategoryAnalytics,
    fitlersClearAnalytics = _ref.fitlersClearAnalytics;
  var _React$useState = React.useState(filters),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    stateFilters = _React$useState2[0],
    setStateFilters = _React$useState2[1];
  var _React$useState3 = React.useState(label),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    appliedFiltersLabel = _React$useState4[0],
    setAppliedFiltersLabel = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    appliedFormattedLabel = _React$useState6[0],
    setAppliedFormattedLabel = _React$useState6[1];
  var history = useHistory();
  var checkedOptions = React.useRef(filters);
  React.useEffect(function () {
    setStateFilters(filters);
    if (!filters || !filters.length) {
      setAppliedFiltersLabel(label);
      setAppliedFormattedLabel([]);
      checkedOptions.current = [];
    }
  }, [filters]);
  React.useEffect(function () {
    if (mobileCheck() && !compareArray(stateFilters, filters)) {
      setFilterMultipleChoicesState(stateFilters, filterName, true);
    }
  }, [stateFilters]);
  React.useEffect(function () {
    if (stateFilters.length) {
      var tmpArr = [];
      filterItems.forEach(function (_ref2) {
        var key = _ref2.key,
          label = _ref2.label;
        if (stateFilters.includes(key)) {
          tmpArr.push(label);
        }
      });
      setAppliedFormattedLabel(tmpArr);
      setAppliedFiltersLabel(tmpArr.join(', '));
    } else {
      setAppliedFormattedLabel([]);
      setAppliedFiltersLabel(label);
    }
  }, []);

  // Open/Close popup
  var toggleFilter = function toggleFilter(e) {
    setFilterDropdownState(!isOpen, filterName);
    e.preventDefault();
  };
  var submitFilters = function submitFilters(e) {
    setFilterMultipleChoicesState(stateFilters, filterName);
    setFilterDropdownState(false, filterName);
    e.preventDefault();
  };
  var clearFilter = function clearFilter(e) {
    resetFilterChoiceState(filterName);
    removeQueryString(filterName, history);
    setAppliedFiltersLabel(label);
    setAppliedFormattedLabel([]);
    checkedOptions.current = [];
    e.preventDefault();
  };
  var itemToggle = function itemToggle(e) {
    var value = e.currentTarget.value;
    var add = e.currentTarget.checked;
    var items = _toConsumableArray(stateFilters);
    var index = items.findIndex(function (item) {
      return item === value;
    });
    index > -1 && !add ? items.splice(index, 1) : add && items.push(value);
    setStateFilters(items);
  };
  var filterItems = formattedItems;
  if (!filterItems) {
    if (items) {
      filterItems = Object.keys(items).map(function (k) {
        return {
          key: k,
          label: k
        };
      });
    }
  }
  if (!filterItems) {
    console.warn('filter setup is incorrect');
    return null;
  }

  // If you check some facet - recalculate amount of results to be shown.
  var amountToBeShown = stateFilters.length ? Object.keys(items).reduce(function (amount, key) {
    if (stateFilters.includes(key)) {
      return amount + items[key];
    }
    return amount;
  }, 0) : resultsAmount;
  var filterLabel = label;
  var setTemporaryLabelOnChange = function setTemporaryLabelOnChange(e) {
    var currentName = e.target.value;
    if (!checkedOptions.current.includes(currentName)) {
      checkedOptions.current = [].concat(_toConsumableArray(checkedOptions.current), [currentName]);
    } else {
      checkedOptions.current.splice(checkedOptions.current.indexOf(currentName), 1);
    }
    setStateFilters(function () {
      return checkedOptions.current;
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel eloqua ".concat(isOpen ? 'filter-panel--open' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-small filter-panel__mob-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__box ".concat(isOpen ? 'filter-panel__box--openedDrop' : '')
  }, /*#__PURE__*/React.createElement("a", {
    className: "filter-panel__trigger js-filter-panel__trigger",
    href: "/#",
    "aria-label": "Select fitlers Category",
    onClick: function onClick(e) {
      tealiumClickFunc(tealiumMergeClickData(fitlersCategoryAnalytics, params), label);
      toggleFilter(e);
    }
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__text body-small"
  }, checkedOptions.current.length !== 0 ? checkedOptions.current.toString() : label), /*#__PURE__*/React.createElement("img", {
    className: "icon",
    src: IconChevronDown,
    alt: "smth"
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner-scroll"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fp__inner-cb"
  }, /*#__PURE__*/React.createElement("a", {
    className: "body-medium fp__inner-clear",
    href: "/#",
    tabIndex: 0,
    "aria-label": "Clear fitlers",
    onClick: function onClick(e) {
      tealiumClickFunc(tealiumMergeClickData(fitlersClearAnalytics, params));
      clearFilter(e);
    }
  }, clearAllLabel)), filterItems.map(function (item) {
    var key = item.key,
      label = item.label;
    return /*#__PURE__*/React.createElement("label", {
      tabIndex: 0,
      onKeyPress: function onKeyPress(event) {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          event.preventDefault();
          event.target.click();
        }
      },
      className: "checkbox-aligned fp__inner-label ".concat(customCheckboxCss),
      htmlFor: key.replace(/\s/g, '_'),
      key: key
    }, /*#__PURE__*/React.createElement("input", {
      checked: stateFilters.includes(key),
      className: "input-choice fp__checkbox",
      type: "checkbox",
      name: filterName,
      value: key,
      id: key.replace(/\s/g, '_'),
      onChange: function onChange(e) {
        tealiumClickFunc(tealiumMergeClickData(fitlersValueAnalytics, params), [filterLabel, label]);
        itemToggle(e);
        if (e.target.checked) {
          setAppliedFormattedLabel([].concat(_toConsumableArray(appliedFormattedLabel), [label]));
        } else {
          setAppliedFormattedLabel(appliedFormattedLabel.filter(function (item) {
            return item !== label;
          }));
        }
        setTemporaryLabelOnChange(e);
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: 'fp__checkbox-label'
    }), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-text"
    }, label, " (", items[key], ")"), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-bg"
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__bottom"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary js-btn-close-panel",
    tabIndex: 0,
    onClick: function onClick(e) {
      tealiumClickFunc(tealiumMergeClickData(filtersShowResultsAnalytics, params), filterLabel);
      submitFilters(e);
      setAppliedFiltersLabel(appliedFormattedLabel.length ? appliedFormattedLabel.join(', ') : label);
    }
  }, showNResultsLabel.replace('{#resultsAmount#}', '')))))));
};
var customCheckboxCss = "cfrjp5s";
export default MultiFilter;